function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { stateGo } from 'redux-ui-router';
import __ from 'ramda/src/__';
import findIndex from 'ramda/src/findIndex';
import pathOr from 'ramda/src/pathOr';
import moment from 'moment';
import clone from 'ramda/src/clone';
import debounce from 'lodash/debounce';
import i18n from 'invision-core/src/components/i18n/i18n';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { IsConvergentBillerSelector } from 'invision-core/src/components/metadata/codes/codes.selectors.deprecated';
import { LastRouteSelector } from 'invision-core/src/components/session/session.selectors';
import { MetadataCodeLoadedSelector, MetadataCodeTypeIntegerSelector, MetadataOptionsForCodeValuesWithoutPlaceholderSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { registerUnsavedChanges, unregisterUnsavedChanges } from 'invision-core/src/components/unsavedChangesPrompt/actions';
import { loadCodeTables } from 'invision-core/src/components/metadata/codes/codes.helpers';
import { getShippingMethodsByCountryCode } from 'invision-core/src/components/metadata/shippingMethods/shipping.methods.actions';
import LocaleKeys from '../../../../locales/keys';
import { STATE_NAME } from './transition.offer.wizard.constants';
import { ContextOfferingAction } from '../../../../reducers/constants/wizard.constants';
import { ShowCustomerAutoPayBannerSelector } from '../../../../reducers/selectors/customer.account.status.selectors';
import { duplicatedServiceIdentifierAttributes } from '../../../../reducers/helpers/offer.ordering.wizard.helper';
import { EwalletErrorSelector, SelectedPaymentAutoPayEnable, SelectedPaymentMethodSelector, SelectedPaymentForSubmitAtCheckoutSelector, RecordPaymentInformationSelector, SupplyPaymentInstrumentSelector } from '../../../../reducers/selectors/customer.ewallet.selectors';
import { AllAttributesAreValidSelector, AttributeServiceSelector, CurrentActiveAttributeNameSelector, FilteredFormAttributeGroups, FilteredPhysicalAttributeGroups, FinancedProductGroupInCartSelector, HasRequiredAndUnavailableInventorySelector, ShowNextButtonSelector, ShowPreviousButtonSelector } from './transition.offer.wizard.selectors';
import { AvailableCreditFromQuoteSelector, AvailableFinanceCreditFromQuoteSelector, BackButtonTextSelector, CartAdditionalPropertiesSelector, CartAdditionalPropertyListMapSelector, CompletedStepsSelector, CurrentStepIndexSelector, CurrentStepIsInvalidSelector, CurrentStepSelector, DeliveryOptionsByPricingPlanSelector, EditOptionSelector, EditOptionsSelector, EditSelectedFacetIdsSelector, EditSelectedOfferingChargeTypeIdSelector, FormattedCityStateSelector, FormAttributeGroups, FormPhysicalAttributeGroups, FormattedPhysicalAttributesSelector, FormattedAttributesSelector, FormattedDeliveryDecisionsSelector, FormattedNameSelector, ForwardButtonTextSelector, IsAttributesStepSelector, IsCheckoutStepSelector, IsCompareOffersStepSelector, IsCreditLimitBreachedFromQuoteSelector, IsDecisionsStepSelector, IsOffersStepSelector, IsResumingStoreOrderSelector, IsSendToStoreButtonEnabledSelector, IsSubmittingCOSOrderSelector, IsSummaryTabVisibleSelector, OfferOptionViewModelSelector, OrderAdditionalPropertiesSelector, OrderAdditionalPropertyListMapSelector, PaymentInfoEditSelector, PaymentInfoSelector, IsShippingRequiredSelector, IsSubscriberProductIdUndefinedSelector, QuoteHasInvoiceItemsSelector, ShippingAddressSelector, ShippingAddressDropdownOptionsSelector, SelectedOfferIdSelector, SelectedOfferingResponseIdSelector, SelectedTabIndexSelector, ServiceAddressSelector, ServiceTaxDecisionsSelector, SkippedStepSelector, StepProgressBarViewModelSelector, SummaryTabViewModelSelector, TabPanelViewModelSelector, TaxLocationDecisionsByPricingPlanChangeOfferSelector, TransitionContextSelector, TransitionLastAttemptErrorSelector, TransitionOfferDeliveryMethodOptionsSelector, TransitionOfferingInstanceIdSelector, TransitionOfferSubmittedCOSSelector, TransitionOutcomesSelector } from '../../../../reducers/selectors/transition.offer.wizard.selectors';
import { setIsResumingStoreOrder } from '../../../../reducers/actions/add.offer.wizard.actions';
import { DEBOUNCE_TIME_MS, DELIVERY_OPTIONS, DUPLICATE_SERVICE_IDENTIFIER_FAULT_CODE, EXISTING_SAVED_CART_FOR_SEND_TO_STORE_FAULT_CODE, ORDER_SCENARIOS, RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION } from '../../../../customercare.constants';
import { GroupedCheckboxFilterOptionsSelector } from '../create/offer/add.offer.wizard.selectors';
import { FullCartOfferingOrderQuotesSelector, FullCartOfferingOrderQuoteTotalSelector, FullCartOfferingOrderFeeQuoteSelector, FullCartOfferingOrderTaxQuoteSelector, FullCartOfferingOrderShippingQuoteSelector, ShowHideFullCartColumnsSelector } from '../../../../reducers/selectors/full.cart.selectors';
import { CurrentCustomerCreditLimitSelector, CurrentCustomerSelector, CurrentCustomerIdSelector, StoreOrderSelector, SelectedCustomerHomeCountrySelector } from '../../../../reducers/selectors/customer.selectors';
import { beginTransitionOfferOrder, cancelOrder, clearQuoteAndSetSelectedOffer, fetchAddresses, fetchDecisionsAndNavigate, fetchAttributes, fetchAttributesQuoteAndNavigate, fetchPreviousAttributesAndNavigate, fetchWallet, goToNextStep, goToPreviousStep, goToStep, restoreOptionDefaultPricing, resumeStoreOrderForTransition, saveBulkPricing, searchAttributeInventory, sendPortInOrItemReservation, setCurrentStepIsInvalid, setEditAttributeGroups, setEditOption, setEditCartAdditionalProperty, setEditCartAdditionalPropertyOnChange, setEditOrderAdditionalProperty, setEditOrderAdditionalPropertyOnChange, setEditPhysicalAttributeGroups, setPaymentInfo, setSelectedFacetsEditCopy, setSelectedOffer, setSelectedOfferingChargeTypesEditCopy, setSelectedOfferEditCopy, setSelectedTab, transitionOfferSubmitCosOrder, updateAttribute, updateBillCycle, updateCart, updateEditOptionPrice, updateInventorySelection, updateOfferPhysicalInventoryMakeAndModel, updateOfferPhysicalInventoryTypeAttribute, updatePortInRequest, updateSelectedServiceFeatures, updatePaymentInfo, updateServiceTaxLocationDecisionChangeOffer } from '../../../../reducers/actions/transition.offer.wizard.actions';
import { AddItemsSelector, AllPhysicalInventoryItemsFromSelectedOffering, AttributeFormSubmittedSelector, CartContainsOffcycleOfferSelector, CompletedDecisionsSelector, FilteredStoresOnSelectedRegionForStoresSearchModalSelector, HasOffCycleChargeRenewalSelector, IsAllSelectedPhysicalInventoryPresentAtSelectedStore, InventoryAvailabilitySelector, ModifyItemsSelector, PagesIsFetchingDataSelector, PaymentInstrumentRequiredSelector, PhysicalAttributeDecisionsSelector, PhysicalAttributeGroupsSelector, RemoveItemsSelector, SelectedOfferChangesEffectiveSelector, SelectedOfferingPhysicalInventoryAvailabilitySelector, SelectedOfferingPickupIdSelector, SelectedOfferingServiceIdentifiersSelector, SelectedOfferingStoreAvailabilitySelector, ShoppingCartIsPostpaidSelector, SubmittedOrderErrorSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
import { DbssShippingEnabledRegionIdSelector, FullCartAsyncStatusSelector, InventoryStorePickupDetailsSelector, InventoryStoresTableDataSelector, IsAsyncCompleteSelector, IsFullCartAsyncCompleteSelector, IsInventoryStoreConfiguredSelector, IsQuoteBypassedSelector, IsQuotingOfferSelector, OffcycleRenewalScheduleSelector, OfferingOrderAsyncIdSelector, OfferingOrderQuoteSelector, QuoteCalculatedSelector, SelectedDeliveryDecisionSelector, SelectedInventoryRegionSelector, SelectedInventoryStoresDetailsSelector, SelectedOrderExecutionOptionsSelector, SelectedShippingAddressAndMethodSelector, SubscriptionOrderQuoteSelector } from '../../../../reducers/selectors/offering.order.selectors';
import { calculateChangeOfServiceOfferingOrderQuote, resetAvailableInventoryInformation, retrieveOffCycleNextRenewalSchedules, retrieveOfferingOrderQuote, retrieveOrderQuote, searchInventoriesAvailability, sendInventoryToStore, setActiveAttributeFormName, setAttributeFormSubmitted, setDevicePaymentOptions, setInventoryRegionFilter, setSelectedInventoryStores } from '../../../../reducers/actions/offering.order.actions';
import { cancelStoreOrder, setCustomerCategory } from '../../../../reducers/actions/customer.actions';
import { setCustomerAutoPayBannerFlag } from '../../../../reducers/actions/customer.account.status.actions';
import { OfferWizard } from '../offer.wizard.common';
import { CUSTOMER_URL } from '../../../customer/customer.config';
import { MINI_CART_MORE_ACTIONS, moreActionMenuItems } from '../../../wizards/tabs/summaryTab/summary.tab.helper';
import { asyncRepeatInterval } from '../../../../reducers/helpers/async.helper';
import { FormattedEditCustomerSubscriberIdentitiesSelector } from '../../../../reducers/selectors/customer.information.selectors';
import { CurrentCustomerNodeSelector } from '../../../../reducers/selectors/customer.account.hierarchy.selectors';
import { REPORTING_LEVELS } from '../../accountHierarchy/account.hierarchy.constants';
import { CUSTOMER_CATEGORY } from '../../../createCustomerPopup/create.customer.popup.constants';
var TransitionOfferWizardController = /*#__PURE__*/function (_OfferWizard) {
  function TransitionOfferWizardController($scope, $ngRedux, $interval, $filter, $state, $stateParams, $timeout, uiNotificationService, unsavedChangesPrompt) {
    var _this;
    _classCallCheck(this, TransitionOfferWizardController);
    _this = _callSuper(this, TransitionOfferWizardController);
    Object.assign(_this, {
      $ngRedux: $ngRedux,
      $interval: $interval,
      $filter: $filter,
      $scope: $scope,
      $state: $state,
      $timeout: $timeout,
      autoPayBannerFlag: false,
      customerCategory: CUSTOMER_CATEGORY,
      initialServiceFeatures: {},
      LocaleKeys: LocaleKeys,
      miniCartMoreActionMenuItems: moreActionMenuItems([MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER]),
      offerId: $stateParams.offeringId,
      offeringInstanceId: $stateParams.offeringInstanceId,
      overrideBypassQuoteConfiguration: false,
      REPORTING_LEVELS: REPORTING_LEVELS,
      retrieveOfferingOrderQuoteTimestamp: null,
      retrieveOrderQuoteTimestamp: null,
      stateName: STATE_NAME,
      submitChangeOrderErrorPopupApi: null,
      uiNotificationService: uiNotificationService,
      unsavedChangesPrompt: unsavedChangesPrompt,
      closeSearchInventoryPopupDialog: _this.closeSearchInventoryPopupDialog.bind(_this),
      closeSelectStorePopupDialog: _this.closeSelectStorePopupDialog.bind(_this),
      closeSendToStorePopup: _this.closeSendToStorePopup.bind(_this),
      closeViewFullCartPopupDialog: _this.closeViewFullCartPopupDialog.bind(_this),
      DELIVERY_OPTIONS: DELIVERY_OPTIONS,
      handleCloseSubmitChangeOrderErrorPopup: _this.handleCloseSubmitChangeOrderErrorPopup.bind(_this),
      handleSubmitForPickupErrorPopup: _this.handleSubmitForPickupErrorPopup.bind(_this),
      handleSubmitForPickupCancel: _this.handleSubmitForPickupCancel.bind(_this),
      handleSendToStore: _this.handleSendToStore.bind(_this),
      onCartAdditionalPropertyChanged: _this.onCartAdditionalPropertyChanged.bind(_this),
      onCartAdditionalPropertyListUpdated: _this.onCartAdditionalPropertyListUpdated.bind(_this),
      onInventoryRegionFilterChanged: _this.onInventoryRegionFilterChanged.bind(_this),
      onInventoryRegionFilterChangedForStoreSearch: _this.onInventoryRegionFilterChangedForStoreSearch.bind(_this),
      onMoreActionSelected: _this.onMoreActionSelected.bind(_this),
      onOfferingDeselected: _this.onOfferingDeselected.bind(_this),
      onOfferSelected: _this.onOfferSelected.bind(_this),
      onOrderAdditionalPropertyChanged: _this.onOrderAdditionalPropertyChanged.bind(_this),
      onOrderAdditionalPropertyListUpdated: _this.onOrderAdditionalPropertyListUpdated.bind(_this),
      onOverrideCalculateQuote: _this.onOverrideCalculateQuote.bind(_this),
      onRefreshOfferingQuote: _this.onRefreshOfferingQuote.bind(_this),
      onRefreshQuote: _this.onRefreshQuote.bind(_this),
      onSelectInventoryStore: _this.onSelectInventoryStore.bind(_this),
      onUpdateSelectedServiceFeatures: _this.onUpdateSelectedServiceFeatures.bind(_this),
      openStoreSearch: _this.openStoreSearch.bind(_this),
      recalculateOrderQuote: _this.recalculateOrderQuote.bind(_this),
      recallOfferingContext: _this.recallOfferingContext.bind(_this),
      repeatRetrieveOfferingQuote: _this.repeatRetrieveOfferingQuote.bind(_this),
      repeatRetrieveQuote: _this.repeatRetrieveQuote.bind(_this),
      setSelectedStoreForSearchModal: _this.setSelectedStoreForSearchModal.bind(_this),
      updateCart: _this.updateCart.bind(_this)
    });
    Promise.all(loadCodeTables(_this.$ngRedux.getState(), _this.$ngRedux.dispatch, [CODES.FinanceBillerRuleConfiguration, CODES.InventoryRegion, CODES.OneTimeBillerRuleConfiguration, CODES.RecurringBillerRuleConfiguration, CODES.Stores])).catch(function (error) {
      _this.uiNotificationService.transientError(error.translatedMessage);
    });
    return _this;
  }
  _inherits(TransitionOfferWizardController, _OfferWizard);
  return _createClass(TransitionOfferWizardController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this.creditCheckPopupApi = null;
      this.isFormDirty = false;
      this.contextOfferingAction = ContextOfferingAction.TRANSITION;
      this.disconnectRedux = this.connectRedux();
      this.orderScenarios = ORDER_SCENARIOS;
      this.cartMessages = [this.LocaleKeys.CART_SUMMARY.QUOTE_SUMMARY];
      this.debouncedAttemptNextStep = debounce(this.attemptNextStep, DEBOUNCE_TIME_MS);
      this.actions.fetchAddresses(this.state.customerId);
      this.actions.setCustomerCategory(this.state.customerInfo.Category);
      this.actions.fetchWallet(this.state.customerId).catch(function () {
        if (_this2.state.retrieveEwalletError) {
          _this2.uiNotificationService.error(_this2.state.retrieveEwalletError.message);
        }
      });
      this.EditSelectedOfferingChargeTypeIdSelector = EditSelectedOfferingChargeTypeIdSelector;
      this.EditSelectedFacetIdsSelector = EditSelectedFacetIdsSelector;
      this.actions.beginTransitionOfferOrder();
      this.actions.registerUnsavedChanges('wizardForm', {
        isDirty: function isDirty() {
          return _this2.isFormDirty;
        },
        setPristine: function setPristine() {
          _this2.actions.unregisterUnsavedChanges('wizardForm');
        }
      });
      // hook the order confirmation popupApi
      this.changeOrderConfirmationPopup = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this2.changeOrderConfirmationPopup = api;
        }
      };
      this.viewFullCartPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.viewFullCartPopupApi = event.api;
        }
      };
      this.sendToStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this2.sendToStorePopupApi = api;
        }
      };

      // hook the submit order error popupApi
      this.submitChangeOrderErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this2.submitChangeOrderErrorPopupApi = api;
        }
      };
      this.submitForPickupErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this2.submitForPickupErrorPopupApi = api;
        }
      };
      this.offersFilter = function (offer) {
        // ITV Offers are pre-paid only & contain Subscription property
        return offer.Prepaid && !_this2.state.isDbss || !(offer.ContainsBulkPlans || offer.Prepaid);
      };
      this._previewRenewalStatementsPopupApi = null;
      this.showPreviewRenewalStatementsDialog = false;
      this.previewRenewalStatementsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2._previewRenewalStatementsPopupApi = event.api;
        }
      };
      this.handlePreviewRenewalStatements = function () {
        _this2._openPreviewRenewalStatementsPopup();
      };
      this.handleClosePreviewRenewalStatementsDialog = function () {
        _this2._closePreviewRenewalStatementsPopup();
      };
      this.goToPreviousStep = function () {
        if (_this2.state.isCheckoutStep) {
          _this2.actions.setPaymentInfo(_this2.state.paymentInfoEdit);
        }
        if (_this2.state.isDecisionsStep) {
          _this2.actions.setAttributeFormSubmitted(false);
          _this2.actions.setActiveAttributeFormName(null);
        }
        if (_this2.state.isAttributesStep && _this2.isAttributesFormInvalid()) {
          _this2.wizardForm.$setSubmitted();
          _this2.actions.setAttributeFormSubmitted(true);
          return;
        }
        _this2.actions.goToPreviousStep();
      };
      this.creditCheckPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref5) {
          var api = _ref5.api;
          _this2.creditCheckPopupApi = api;
        }
      };
      this.openCreditCheckModal = function () {
        _this2.creditCheckPopupApi.open();
      };
      this.storeSearchInventoryConfig = {
        onRegisterApi: function onRegisterApi(_ref6) {
          var api = _ref6.api;
          _this2.storeSearchInventoryApi = api;
        }
      };
      this.selectStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref7) {
          var api = _ref7.api;
          _this2.selectStorePopupApi = api;
        }
      };
      /*
          For the resumeStoreOrder scenario in edit or change offer, when we hit
          the `sendToStore` API unlike `addOffer` we do not send along a saved shopping cart.
          Therefore we do not need to update the shopping cart like in add since we do not get back
          a shopping cart from the API.
      */
      if (this.state.isResumingStoreOrder) {
        this.actions.resumeStoreOrderForTransition(this.state.customerId, this.state.storeOrder).catch(function (err) {
          _this2.uiNotificationService.transientError(err.translatedMessage);
        });
      }
      if (this.state.isDbss) {
        this.actions.getShippingMethodsByCountryCode(this.state.selectedCustomerHomeCountry).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "_openPreviewRenewalStatementsPopup",
    value: function _openPreviewRenewalStatementsPopup() {
      this.showPreviewRenewalStatementsDialog = true;
      this.$timeout(this._previewRenewalStatementsPopupApi.open);
    }
  }, {
    key: "_closePreviewRenewalStatementsPopup",
    value: function _closePreviewRenewalStatementsPopup() {
      this.showPreviewRenewalStatementsDialog = false;
      this._previewRenewalStatementsPopupApi.close();
    }
  }, {
    key: "openViewFullCartPopupDialog",
    value: function openViewFullCartPopupDialog() {
      this.showViewFullCartPopup = true;
      this.$timeout(this.viewFullCartPopupApi.open);
    }
  }, {
    key: "closeViewFullCartPopupDialog",
    value: function closeViewFullCartPopupDialog() {
      this.showViewFullCartPopup = false;
      this.viewFullCartPopupApi.close();
    }
  }, {
    key: "onOverrideCalculateQuote",
    value: function onOverrideCalculateQuote() {
      this.overrideBypassQuoteConfiguration = true;
      this.recalculateOrderQuote();
    }
  }, {
    key: "recalculateOrderQuote",
    value: function recalculateOrderQuote() {
      var _this3 = this;
      this.actions.calculateChangeOfServiceOfferingOrderQuote(this.state.customerInfo, this.state.transitionOfferingInstanceId, this.state.addedItems, this.state.removedItems, this.state.modifiedItems, this.state.executionOptions, undefined, this.state.selectedShippingAddressAndMethod, !!this.state.shippingAddress, this.overrideBypassQuoteConfiguration).then(function () {
        if (_this3.state.offeringOrderAsyncId) {
          _this3.repeatRetrieveQuote();
        }
      }).catch(function (error) {
        _this3.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onViewFullCartRequest",
    value: function onViewFullCartRequest() {
      var _this4 = this;
      if (this.state.offeringOrderAsyncId) {
        this.repeatRetrieveOfferingQuote();
        this.openViewFullCartPopupDialog();
      } else {
        if (!Object.keys(this.state.offeringOrderQuote).length) {
          this.actions.calculateChangeOfServiceOfferingOrderQuote(this.state.customerInfo, this.state.transitionOfferingInstanceId, this.state.addedItems, this.state.removedItems, this.state.modifiedItems, this.state.executionOptions, undefined, this.state.selectedShippingAddressAndMethod, undefined, this.overrideBypassQuoteConfiguration).then(function () {
            if (_this4.state.cartContainsOffcycleOffer) {
              _this4.actions.retrieveOffCycleNextRenewalSchedules(_this4.state.customerInfo.Id, _this4.state.addedItems, _this4.state.modifiedItems, _this4.state.removedItems).catch(function (error) {
                _this4.uiNotificationService.transientError(error.translatedMessage);
              });
            }
            _this4.openViewFullCartPopupDialog();
          }).catch(function (error) {
            _this4.uiNotificationService.transientError(error.translatedMessage);
          });
        } else {
          if (this.state.cartContainsOffcycleOffer) {
            this.actions.retrieveOffCycleNextRenewalSchedules(this.state.customerInfo.Id, this.state.addedItems, this.state.modifiedItems, this.state.removedItems).catch(function (error) {
              _this4.uiNotificationService.transientError(error.translatedMessage);
            });
          }
          this.openViewFullCartPopupDialog();
        }
      }
    }
  }, {
    key: "gotoDecisionsPage",
    value: function gotoDecisionsPage() {
      this.closeViewFullCartPopupDialog();
      this.actions.goToStep(LocaleKeys.WIZARD.STEPS.DECISIONS);
    }
  }, {
    key: "connectRedux",
    value: function connectRedux() {
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addedItems: AddItemsSelector(store),
          additionalPropValueOptions: MetadataCodeTypeIntegerSelector(CODES.AdditionalPropertyValue, store),
          allAttributesAreValid: AllAttributesAreValidSelector(store),
          attributeFormSubmitted: AttributeFormSubmittedSelector(store),
          availableCreditFromQuote: AvailableCreditFromQuoteSelector(store),
          availableFinanceCreditFromQuote: AvailableFinanceCreditFromQuoteSelector(store),
          availableInventoryInformation: InventoryAvailabilitySelector(store),
          backButtonText: BackButtonTextSelector(store),
          cartAdditionalProperties: CartAdditionalPropertiesSelector(store),
          cartAdditionalPropertyListMap: CartAdditionalPropertyListMapSelector(store),
          cartContainsOffcycleOffer: CartContainsOffcycleOfferSelector(store),
          changesEffective: SelectedOfferChangesEffectiveSelector(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          completedDecisions: CompletedDecisionsSelector(store),
          completedSteps: CompletedStepsSelector(store),
          currentAttributeTitle: CurrentActiveAttributeNameSelector(store),
          currentCustomerCreditLimit: CurrentCustomerCreditLimitSelector(store),
          currentCustomerNode: CurrentCustomerNodeSelector(store),
          currentStep: CurrentStepSelector(store),
          currentStepIndex: CurrentStepIndexSelector(store),
          currentStepIsInvalid: CurrentStepIsInvalidSelector(store),
          customerId: CurrentCustomerIdSelector(store),
          customerInfo: CurrentCustomerSelector(store),
          dbssShippingEnabledRegionId: DbssShippingEnabledRegionIdSelector(store),
          deliveryMethodOptions: TransitionOfferDeliveryMethodOptionsSelector(store),
          deliveryOptionsByPricingPlan: DeliveryOptionsByPricingPlanSelector(store),
          executionOptions: SelectedOrderExecutionOptionsSelector(store),
          editOption: EditOptionSelector(store),
          editOptions: EditOptionsSelector(store),
          filteredFormAttributeGroups: FilteredFormAttributeGroups(store),
          filteredPhysicalAttributeGroups: FilteredPhysicalAttributeGroups(store),
          filteredStoresOnSelectedRegionForStoresSearchModal: FilteredStoresOnSelectedRegionForStoresSearchModalSelector(store),
          financedProductGroupInCart: FinancedProductGroupInCartSelector(store),
          formattedEditCustomerSubscriberIdentities: FormattedEditCustomerSubscriberIdentitiesSelector(store),
          formattedAttributes: FormattedAttributesSelector(store),
          formattedCityState: FormattedCityStateSelector(store),
          formattedDeliveryDecisions: FormattedDeliveryDecisionsSelector(store),
          formattedName: FormattedNameSelector(store),
          formattedPhysicalAttributes: FormattedPhysicalAttributesSelector(store),
          formattedPhysicalInventories: SelectedOfferingPhysicalInventoryAvailabilitySelector(store),
          formAttributeGroups: FormAttributeGroups(store),
          formPhysicalAttributeGroups: FormPhysicalAttributeGroups(store),
          forwardButtonText: ForwardButtonTextSelector(store),
          fullCartAsyncStatus: FullCartAsyncStatusSelector(store),
          fullCartOfferingOrderQuotes: FullCartOfferingOrderQuotesSelector(store),
          fullCartOfferingOrderQuoteTotal: FullCartOfferingOrderQuoteTotalSelector(store),
          fullCartOfferingOrderFeeQuote: FullCartOfferingOrderFeeQuoteSelector(store),
          fullCartOfferingOrderTaxQuote: FullCartOfferingOrderTaxQuoteSelector(store),
          fullCartOfferingOrderShippingQuote: FullCartOfferingOrderShippingQuoteSelector(store),
          groupedCheckboxFilterOptions: GroupedCheckboxFilterOptionsSelector(store),
          hasInvoiceItems: QuoteHasInvoiceItemsSelector(store),
          hasOffCycleChargeRenewal: HasOffCycleChargeRenewalSelector(store),
          hasRequiredAndUnavailableInventory: HasRequiredAndUnavailableInventorySelector(store),
          inventoryRegions: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.InventoryRegion, store),
          inventoryStorePickupDetails: InventoryStorePickupDetailsSelector(store),
          isAllSelectedPhysicalInventoryAvailable: IsAllSelectedPhysicalInventoryPresentAtSelectedStore(store),
          isAttributesStep: IsAttributesStepSelector(store),
          isCalculatingQuote: IsQuotingOfferSelector(store),
          isCheckoutStep: IsCheckoutStepSelector(store),
          isCompareOffersStep: IsCompareOffersStepSelector(store),
          isConvergentBiller: IsConvergentBillerSelector(store),
          isCreditLimitBreached: IsCreditLimitBreachedFromQuoteSelector(store),
          isDbss: IsDbss(store),
          isDecisionsStep: IsDecisionsStepSelector(store),
          isAsyncComplete: IsAsyncCompleteSelector(store),
          isFetchingDecisionsOrAttributes: PagesIsFetchingDataSelector(store),
          isFullCartAsyncComplete: IsFullCartAsyncCompleteSelector(store),
          isInventoryStoreConfigured: IsInventoryStoreConfiguredSelector(store),
          isOffersStep: IsOffersStepSelector(store),
          isQuoteBypassed: IsQuoteBypassedSelector(store),
          isQuoteCalculated: QuoteCalculatedSelector(store),
          isResumingStoreOrder: IsResumingStoreOrderSelector(store),
          isSendToStoreButtonEnabled: IsSendToStoreButtonEnabledSelector(store),
          isShippingRequired: IsShippingRequiredSelector(store),
          isSubmittingCOSOrder: IsSubmittingCOSOrderSelector(store),
          isSummaryTabVisible: IsSummaryTabVisibleSelector(store),
          lastAttemptError: TransitionLastAttemptErrorSelector(store),
          lastRoute: LastRouteSelector(store),
          lastSubmittedOrderAttemptError: SubmittedOrderErrorSelector(store),
          modifiedItems: ModifyItemsSelector(store),
          offcycleRenewalSchedule: OffcycleRenewalScheduleSelector(store),
          offeringOrderAsyncId: OfferingOrderAsyncIdSelector(store),
          offeringOrderQuote: OfferingOrderQuoteSelector(store),
          offerOptionViewModel: OfferOptionViewModelSelector(store),
          orderAdditionalProperties: OrderAdditionalPropertiesSelector(store),
          orderAdditionalPropertyListMap: OrderAdditionalPropertyListMapSelector(store),
          paymentInfo: PaymentInfoSelector(store),
          paymentInfoEdit: PaymentInfoEditSelector(store),
          paymentInstrumentRequired: PaymentInstrumentRequiredSelector(store),
          physicalAttributeGroups: PhysicalAttributeGroupsSelector(store),
          isSubscriberProductIdUndefined: IsSubscriberProductIdUndefinedSelector(store),
          physicalInventories: AllPhysicalInventoryItemsFromSelectedOffering(store),
          physicalInventoriesDecisions: PhysicalAttributeDecisionsSelector(store),
          recordPaymentInfo: RecordPaymentInformationSelector(store),
          removedItems: RemoveItemsSelector(store),
          retrieveEwalletError: EwalletErrorSelector(store),
          rocResponseId: SelectedOfferingResponseIdSelector(store),
          selectedCustomerHomeCountry: SelectedCustomerHomeCountrySelector(store),
          selectedDeliveryDecision: SelectedDeliveryDecisionSelector(store),
          selectedInventoryRegion: SelectedInventoryRegionSelector(store),
          selectedInventoryStores: SelectedInventoryStoresDetailsSelector(store),
          selectedInventoryStoresItemAvailability: SelectedOfferingStoreAvailabilitySelector(store),
          selectedOfferId: SelectedOfferIdSelector(store),
          selectedOfferingPickupId: SelectedOfferingPickupIdSelector(store),
          selectedOfferingServiceIdentifiers: SelectedOfferingServiceIdentifiersSelector(store),
          selectedPayment: SelectedPaymentMethodSelector(store),
          selectedPaymentClean: SelectedPaymentForSubmitAtCheckoutSelector(store),
          selectedPaymentMethodAutoPay: SelectedPaymentAutoPayEnable(store),
          selectedShippingAddressAndMethod: SelectedShippingAddressAndMethodSelector(store),
          selectedTabIndex: SelectedTabIndexSelector(store),
          serviceAddress: ServiceAddressSelector(store),
          services: AttributeServiceSelector(store),
          serviceTaxDecisions: ServiceTaxDecisionsSelector(store),
          shippingAddress: ShippingAddressSelector(store),
          shippingAddressDropdownOptions: ShippingAddressDropdownOptionsSelector(store),
          shoppingCartIsPostpaid: ShoppingCartIsPostpaidSelector(store),
          shouldShowNextButton: ShowNextButtonSelector(store),
          shouldShowPreviousButton: ShowPreviousButtonSelector(store),
          showCustomerAutoPayBanner: ShowCustomerAutoPayBannerSelector(store),
          showHideFullCartColumns: ShowHideFullCartColumnsSelector(store),
          skippedStep: SkippedStepSelector(store),
          stepProgressBarViewModel: StepProgressBarViewModelSelector(store),
          storeOrder: StoreOrderSelector(store),
          storesTableData: InventoryStoresTableDataSelector(store),
          submittedOrder: TransitionOfferSubmittedCOSSelector(store),
          subscriptionOrderQuotes: SubscriptionOrderQuoteSelector(store),
          subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
          summaryTabViewModel: SummaryTabViewModelSelector(store),
          supplyPaymentInstrument: SupplyPaymentInstrumentSelector(store),
          tabPanelViewModel: TabPanelViewModelSelector(store),
          taxLocationDecisionsByPricingPlanChangeOffer: TaxLocationDecisionsByPricingPlanChangeOfferSelector(store),
          transitionContext: TransitionContextSelector(store),
          transitionOfferingInstanceId: TransitionOfferingInstanceIdSelector(store),
          transitionOutcomes: TransitionOutcomesSelector(store)
        };
      };
      var controllerActions = {
        beginTransitionOfferOrder: beginTransitionOfferOrder,
        calculateChangeOfServiceOfferingOrderQuote: calculateChangeOfServiceOfferingOrderQuote,
        cancelOrder: cancelOrder,
        cancelStoreOrder: cancelStoreOrder,
        fetchAddresses: fetchAddresses,
        fetchAttributes: fetchAttributes,
        fetchCodeTypes: fetchCodeTypes,
        fetchWallet: fetchWallet,
        getShippingMethodsByCountryCode: getShippingMethodsByCountryCode,
        registerUnsavedChanges: registerUnsavedChanges,
        resetAvailableInventoryInformation: resetAvailableInventoryInformation,
        resumeStoreOrderForTransition: resumeStoreOrderForTransition,
        retrieveOffCycleNextRenewalSchedules: retrieveOffCycleNextRenewalSchedules,
        retrieveOfferingOrderQuote: retrieveOfferingOrderQuote,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveOrderQuote: retrieveOrderQuote,
        searchInventoriesAvailability: searchInventoriesAvailability,
        sendInventoryToStore: sendInventoryToStore,
        setActiveAttributeFormName: setActiveAttributeFormName,
        setAttributeFormSubmitted: setAttributeFormSubmitted,
        setCustomerAutoPayBannerFlag: setCustomerAutoPayBannerFlag,
        setCustomerCategory: setCustomerCategory,
        setDevicePaymentOptions: setDevicePaymentOptions,
        setEditCartAdditionalProperty: setEditCartAdditionalProperty,
        setEditCartAdditionalPropertyOnChange: setEditCartAdditionalPropertyOnChange,
        setEditOrderAdditionalProperty: setEditOrderAdditionalProperty,
        setEditOrderAdditionalPropertyOnChange: setEditOrderAdditionalPropertyOnChange,
        setIsResumingStoreOrder: setIsResumingStoreOrder,
        setPaymentInfo: setPaymentInfo,
        stateGo: stateGo,
        transitionOfferSubmitCosOrder: transitionOfferSubmitCosOrder,
        updateBillCycle: updateBillCycle,
        updatePortInRequest: updatePortInRequest,
        updateServiceTaxLocationDecisionChangeOffer: updateServiceTaxLocationDecisionChangeOffer,
        unregisterUnsavedChanges: unregisterUnsavedChanges
      };
      var attributesActions = {
        fetchAttributesQuoteAndNavigate: fetchAttributesQuoteAndNavigate,
        fetchPreviousAttributesAndNavigate: fetchPreviousAttributesAndNavigate,
        searchAttributeInventory: searchAttributeInventory,
        sendPortInOrItemReservation: sendPortInOrItemReservation,
        setEditAttributeGroups: setEditAttributeGroups,
        setEditPhysicalAttributeGroups: setEditPhysicalAttributeGroups,
        updateAttribute: updateAttribute,
        updateInventorySelection: updateInventorySelection,
        updateOfferPhysicalInventoryMakeAndModel: updateOfferPhysicalInventoryMakeAndModel,
        updateOfferPhysicalInventoryTypeAttribute: updateOfferPhysicalInventoryTypeAttribute,
        updateSelectedServiceFeatures: updateSelectedServiceFeatures
      };
      var decisionActions = {
        restoreOptionDefaultPricing: restoreOptionDefaultPricing,
        saveBulkPricing: saveBulkPricing,
        setEditOption: setEditOption,
        updateCart: updateCart,
        updateEditOptionPrice: updateEditOptionPrice
      };
      var offeringActions = {
        clearQuoteAndSetSelectedOffer: clearQuoteAndSetSelectedOffer,
        fetchDecisionsAndNavigate: fetchDecisionsAndNavigate,
        setInventoryRegionFilter: setInventoryRegionFilter,
        setSelectedFacetsEditCopy: setSelectedFacetsEditCopy,
        setSelectedInventoryStores: setSelectedInventoryStores,
        setSelectedOffer: setSelectedOffer,
        setSelectedOfferEditCopy: setSelectedOfferEditCopy,
        setSelectedOfferingChargeTypesEditCopy: setSelectedOfferingChargeTypesEditCopy
      };
      var wizardActions = {
        goToNextStep: goToNextStep,
        goToPreviousStep: goToPreviousStep,
        goToStep: goToStep,
        setCurrentStepIsInvalid: setCurrentStepIsInvalid,
        setSelectedTab: setSelectedTab,
        updatePaymentInfo: updatePaymentInfo
      };
      return this.connectToStore(mapStateToTarget, Object.assign(controllerActions, attributesActions, decisionActions, offeringActions, wizardActions));
    }
  }, {
    key: "cancelTransition",
    value: function cancelTransition() {
      var _this5 = this;
      if (this.isFormDirty) {
        this.unsavedChangesPrompt.showPrompt(function () {
          _this5.actions.cancelOrder();
          _this5.redirectToCustomer();
        });
      } else {
        this.actions.cancelOrder();
        this.redirectToCustomer();
      }
    }
  }, {
    key: "checkCreditandFinanceLimitAndSubmitOrder",
    value: function checkCreditandFinanceLimitAndSubmitOrder(paymentInfo) {
      var isFinanceCreditLimitBreached = this.validateFinanceCreditLimitFromQuote();
      if (!this.state.isCreditLimitBreached && !isFinanceCreditLimitBreached) {
        this.changeOfferSubmitCOSOrder(paymentInfo);
      }
    }
  }, {
    key: "validateFinanceCreditLimitFromQuote",
    value: function validateFinanceCreditLimitFromQuote() {
      return this.state.availableFinanceCreditFromQuote > 0;
    }
  }, {
    key: "repeatRetrieveQuote",
    value: function repeatRetrieveQuote() {
      var _this6 = this;
      asyncRepeatInterval(this.onRefreshQuote, function () {
        return !_this6.state.isAsyncComplete && _this6.state.isCheckoutStep;
      });
    }
  }, {
    key: "onRefreshQuote",
    value: function onRefreshQuote() {
      var _this7 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.customerId, this.state.offeringOrderAsyncId).then(function (response) {
        _this7.retrieveOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        _this7.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "repeatRetrieveOfferingQuote",
    value: function repeatRetrieveOfferingQuote() {
      var _this8 = this;
      if (this.state.offeringOrderQuote.OfferingQuotes.length > 0 && this.state.isFullCartAsyncComplete) {
        this.openViewFullCartPopupDialog();
      } else {
        asyncRepeatInterval(this.onRefreshOfferingQuote, function () {
          return !_this8.state.isFullCartAsyncComplete && _this8.state.isCheckoutStep;
        });
      }
    }
  }, {
    key: "onRefreshOfferingQuote",
    value: function onRefreshOfferingQuote() {
      var _this9 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.customerId, this.state.offeringOrderAsyncId).then(function (response) {
        _this9.retrieveOfferingOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        return _this9.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onOfferSelected",
    value: function onOfferSelected() {
      var _this$actions;
      (_this$actions = this.actions).setSelectedOffer.apply(_this$actions, arguments);
      this.actions.goToNextStep();
      this.actions.retrieveOfferingsMetadata([this.state.selectedOfferId]);
      if (this.state.isResumingStoreOrder) {
        this.actions.setIsResumingStoreOrder(false);
      }
    }
  }, {
    key: "onOfferingDeselected",
    value: function onOfferingDeselected() {
      this.isFormDirty = false;
      if (this.state.isResumingStoreOrder) {
        this.actions.setIsResumingStoreOrder(false);
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var _this10 = this;
      if (!this.state.isSubmittingOrder) {
        this.$timeout(function () {
          _this10.debouncedAttemptNextStep();
        });
      }
    }
  }, {
    key: "isAttributesFormInvalid",
    value: function isAttributesFormInvalid() {
      return this.wizardForm['attributesController.attributesForm'] && this.wizardForm['attributesController.attributesForm'].$invalid || !this.state.allAttributesAreValid;
    }
  }, {
    key: "isCheckoutFormInvalid",
    value: function isCheckoutFormInvalid() {
      return this.wizardForm['$ctrl.paymentInstrumentForm'] && this.wizardForm['$ctrl.paymentInstrumentForm'].$invalid;
    }
  }, {
    key: "recallOfferingContext",
    value: function recallOfferingContext() {
      var _this11 = this;
      this.actions.fetchAttributes({
        offeringId: this.state.selectedOfferId ? this.state.selectedOfferId : this.state.storeOrder.Context.OfferingIds[0],
        offeringInstanceId: this.state.selectedOfferId ? this.state.selectedOfferId : this.state.storeOrder.Context.OfferingIds[0],
        completedDecisions: this.getCompletedDecisions(),
        completedAttributes: this.state.formattedAttributes,
        completedPhysicalAttributes: this.state.formattedPhysicalAttributes,
        isConvergentBiller: this.state.transitionContext,
        transitionOutcomes: this.state.transitionOutcomes
      }).catch(function (error) {
        if (error) {
          _this11.uiNotificationService.transientError(error.translatedMessage);
        }
      });
    }
  }, {
    key: "getCompletedDecisions",
    value: function getCompletedDecisions() {
      return [].concat(_toConsumableArray(this.state.serviceTaxDecisions), _toConsumableArray(this.state.formattedDeliveryDecisions), _toConsumableArray(this.state.completedDecisions));
    }
  }, {
    key: "attemptNextStep",
    value: function attemptNextStep() {
      var _this12 = this;
      var isSendToStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      switch (this.state.currentStep) {
        case this.LocaleKeys.WIZARD.STEPS.OFFERS:
          if (!this.state.currentStepIsInvalid) {
            this.actions.goToNextStep();
            this.isFormDirty = true;
          }
          break;
        case this.LocaleKeys.WIZARD.STEPS.COMPARE_OFFERS:
          if (this.state.rocResponseId && this.state.selectedOfferId === this.state.rocResponseId && this.getCompletedDecisions().length) {
            this.actions.goToNextStep();
          } else {
            this.actions.fetchDecisionsAndNavigate(this.state.selectedOfferId ? this.state.selectedOfferId : pathOr(null, ['Context', 'OfferingIds', '0'], this.state.storeOrder), this.state.customerInfo, {
              transitionContext: this.state.transitionContext,
              grandfatherPricingPlans: true,
              isConvergentBiller: this.state.isConvergentBiller
            }, this.offerId, this.state.transitionOfferingInstanceId, undefined, this.overrideBypassQuoteConfiguration);
            this.wizardForm.$setPristine();
          }
          this.isFormDirty = true;
          break;
        case this.LocaleKeys.WIZARD.STEPS.DECISIONS:
          if (this.state.currentStepIsInvalid) {
            break;
          }
          if (this.state.isResumingStoreOrder) {
            if (this.state.formattedPhysicalAttributes.length === 0) {
              //We are setting this to populate the decition type 4 selectors
              this.actions.setEditPhysicalAttributeGroups({
                physicalAttributeGroups: this.state.physicalAttributeGroups,
                formPhysicalAttributeGroups: this.state.formPhysicalAttributeGroups
              });
            }
            if (this.state.physicalInventoriesDecisions) {
              this.state.physicalInventoriesDecisions.forEach(function (item) {
                item.InventoryType.InventoryTypeAttributes.forEach(function (attribute) {
                  if (attribute) {
                    _this12.actions.updateOfferPhysicalInventoryTypeAttribute(item.PricingPlanId, item.Id, attribute.Id, attribute.SelectedValue);
                  }
                });
              });
            }
            if (!this.state.filteredFormAttributeGroups || this.state.filteredFormAttributeGroups.length === 0) {
              this.actions.setEditAttributeGroups(this.state.attributeGroups);
            }
          }
          this.actions.fetchPreviousAttributesAndNavigate(this.state.customerInfo, this.state.selectedOfferId ? this.state.selectedOfferId : pathOr(null, ['Context', 'OfferingIds', '0'], this.state.storeOrder, this.state.isResumingStoreOrder), this.state.formattedAttributes ? [].concat(_toConsumableArray(this.state.formattedAttributes), _toConsumableArray(this.getCompletedDecisions())) : this.getCompletedDecisions(), this.state.transitionContext, this.offerId, this.state.transitionOfferingInstanceId, this.state.isConvergentBiller, undefined, this.overrideBypassQuoteConfiguration).then(function () {
            if (_this12.state.isResumingStoreOrder) {
              _this12.actions.setIsResumingStoreOrder(false);
            }
            _this12.wizardForm.$setPristine();
          });
          this.isFormDirty = true;
          break;
        case this.LocaleKeys.WIZARD.STEPS.ATTRIBUTES:
          if (!this.state.hasRequiredAndUnavailableInventory) {
            this.actions.setAttributeFormSubmitted(true);
            if (!this.isAttributesFormInvalid() && !duplicatedServiceIdentifierAttributes(this.state.formAttributeGroups).length) {
              if (this.state.formattedPhysicalAttributes.length) {
                this.actions.resetAvailableInventoryInformation();
                this.actions.fetchAttributes({
                  offeringId: this.state.selectedOfferId ? this.state.selectedOfferId : this.state.storeOrder.Context.OfferingIds[0],
                  completedDecisions: this.getCompletedDecisions(),
                  completedAttributes: this.state.formattedAttributes,
                  completedPhysicalAttributes: this.state.formattedPhysicalAttributes,
                  isConvergentBiller: this.state.transitionContext,
                  transitionOutcomes: this.state.transitionOutcomes
                }).then(function () {
                  if (_this12.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                    _this12.actions.setInventoryRegionFilter(_this12.state.dbssShippingEnabledRegionId);
                  }
                  if (_this12.state.selectedInventoryStores.length < 1) {
                    if (isSendToStore || _this12.state.isSubscriberProductIdUndefined) {
                      _this12.openStoreSearch(false, isSendToStore);
                    } else {
                      _this12.handleInventoryAvailabilityContinue();
                    }
                  } else if (isSendToStore || _this12.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                    _this12.actions.searchInventoriesAvailability(_this12.state.formattedPhysicalInventories).then(function () {
                      if (!_this12.state.isAllSelectedPhysicalInventoryAvailable) {
                        if (_this12.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                          _this12.uiNotificationService.transientError(i18n.translate(_this12.LocaleKeys.ATTRIBUTES.UNAVAILABLE_SHIPPING_INVENTORY));
                        } else if (isSendToStore) {
                          _this12.openStoreSearch();
                        }
                      } else if (isSendToStore) {
                        _this12.openSendToStorePopup();
                      } else {
                        _this12.handleInventoryAvailabilityContinue().then(function () {
                          if (_this12.state.offeringOrderAsyncId) {
                            _this12.repeatRetrieveQuote();
                          }
                        });
                      }
                    }).catch(function (err) {
                      if (isSendToStore) {
                        _this12.showStoreInventoryPopup = true;
                        _this12.$timeout(function () {
                          _this12.storeSearchInventoryApi.open();
                        });
                      }
                      _this12.onSearchInventoryAvailabilityFailure(err);
                    });
                  } else {
                    _this12.handleInventoryAvailabilityContinue().then(function () {
                      if (_this12.state.offeringOrderAsyncId) {
                        _this12.repeatRetrieveQuote();
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.Code !== DUPLICATE_SERVICE_IDENTIFIER_FAULT_CODE) {
                    _this12.uiNotificationService.transientError(error.translatedMessage);
                  }
                });
              } else if (isSendToStore) {
                this.openSendToStorePopup();
              } else {
                this.handleInventoryAvailabilityContinue().then(function () {
                  if (_this12.state.offeringOrderAsyncId) {
                    _this12.repeatRetrieveQuote();
                  }
                });
              }
            }
          }
          break;
        case this.LocaleKeys.WIZARD.STEPS.CHECKOUT:
          if (!this.isCheckoutFormInvalid()) {
            if (isSendToStore) {
              if (!this.isAttributesFormInvalid()) {
                if (this.state.selectedInventoryStores.length < 1) {
                  this.openStoreSearch();
                  this.wizardForm.$setPristine();
                } else {
                  this.actions.searchInventoriesAvailability(this.state.formattedPhysicalInventories).then(function () {
                    if (!_this12.state.isAllSelectedPhysicalInventoryAvailable) {
                      _this12.openStoreSearch();
                    } else if (isSendToStore) {
                      _this12.openSendToStorePopup();
                    }
                  });
                }
              }
            } else {
              var paymentInfo;
              if (pathOr(false, ['Id'], this.state.selectedPayment)) {
                paymentInfo = this.state.supplyPaymentInstrument || this.state.paymentInstrumentRequired ? this.state.selectedPaymentClean : null;
              } else {
                this.actions.setPaymentInfo(this.state.paymentInfoEdit);
                paymentInfo = this.state.paymentInfo;
                if (this.state.paymentInfo && this.state.paymentInfo.BillingAddressIsServiceAddress) {
                  paymentInfo = Object.assign({}, paymentInfo, {
                    BillingAddressId: this.state.serviceAddress.Id
                  });
                }
                if (this.state.paymentInfo && !this.state.paymentInfo.BillingAddressIsServiceAddress) {
                  var billingAddress = Object.assign({}, paymentInfo.BillingAddress, {
                    Name: this.state.paymentInfo.BillingAddress.LineOne // Name is required by the API and needs to be unique.
                  });
                  paymentInfo = Object.assign({}, paymentInfo, {
                    BillingAddress: billingAddress
                  });
                }
              }
              this.actions.setCustomerAutoPayBannerFlag(this.state.selectedPaymentMethodAutoPay);
              if (this.state.currentCustomerCreditLimit) {
                this.checkCreditandFinanceLimitAndSubmitOrder(paymentInfo);
              } else {
                this.changeOfferSubmitCOSOrder(paymentInfo);
              }
            }
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: "handleInventoryAvailabilityContinue",
    value: function handleInventoryAvailabilityContinue(isSendToStore) {
      var _this13 = this;
      if (isSendToStore) {
        this.openSendToStorePopup();
      } else {
        return this.actions.fetchAttributesQuoteAndNavigate(this.state.customerInfo, this.state.selectedOfferId ? this.state.selectedOfferId : this.state.storeOrder.Context.OfferingIds[0], this.getCompletedDecisions(), this.state.formattedAttributes, this.state.formattedPhysicalAttributes, this.state.transitionContext, undefined, this.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED, !isSendToStore, this.state.transitionOfferingInstanceId, this.overrideBypassQuoteConfiguration).then(function () {
          if (_this13.state.offeringOrderAsyncId) {
            _this13.repeatRetrieveQuote();
          }
        }).then(function () {
          _this13.wizardForm.$setPristine();
        });
      }
    }
  }, {
    key: "openSendToStorePopup",
    value: function openSendToStorePopup() {
      var _this14 = this;
      this.sendToStorePickupDetailsConfig = {
        maxDate: undefined,
        minDate: Date.now()
      };
      this.showSendToStorePopup = true;
      this.$timeout(function () {
        _this14.sendToStorePopupApi.open();
      });
    }
  }, {
    key: "closeSendToStorePopup",
    value: function closeSendToStorePopup() {
      this.showSendToStorePopup = false;
      this.sendToStorePopupApi.close();
    }
  }, {
    key: "onInventoryRegionFilterChangedForStoreSearch",
    value: function onInventoryRegionFilterChangedForStoreSearch(region) {
      this.actions.setInventoryRegionFilter(region);
      this.actions.resetAvailableInventoryInformation();
      var formattedInventories = this.state.physicalInventories,
        formattedPayload = !this.state.formattedInventories ? {
          InventoryTypes: formattedInventories,
          RegionId: region
        } : this.state.formattedPhysicalInventories;
      this.actions.searchInventoriesAvailability(formattedPayload).catch(this.onSearchInventoryAvailabilityFailure);
    }
  }, {
    key: "setSelectedStoreForSearchModal",
    value: function setSelectedStoreForSearchModal(selectedStore) {
      this.actions.setSelectedInventoryStores([selectedStore]);
      this.showStoreInventoryPopup = false;
      this.storeSearchInventoryApi.close();
      if (this.state.isSubscriberProductIdUndefined) {
        this.handleInventoryAvailabilityContinue(this.isSubmitForPickUp);
      }
    }
  }, {
    key: "closeSearchInventoryPopupDialog",
    value: function closeSearchInventoryPopupDialog() {
      this.showStoreInventoryPopup = false;
      this.actions.setInventoryRegionFilter(null);
      this.storeSearchInventoryApi.close();
      if (this.isInventoryItemReservationFault) {
        this.openSendToStorePopup();
      }
    }
  }, {
    key: "handleSendToStore",
    value: function handleSendToStore() {
      var _this15 = this;
      var offering = {
        Action: ContextOfferingAction.TRANSITION,
        OfferingId: this.state.selectedOfferId ? this.state.selectedOfferId : this.state.rocResponseId
      };
      var transitionOfferingIds = {
        transitionSourceOfferingId: this.offerId,
        transitionSourceOfferingInstanceId: this.offeringInstanceId
      };
      this.isSendToStoreLoading = true;
      var completedDecisions = [].concat(_toConsumableArray(this.state.formattedAttributes), _toConsumableArray(this.getCompletedDecisions()), _toConsumableArray(this.state.formattedPhysicalAttributes));
      this.actions.sendInventoryToStore(this.state.customerInfo.Id, this.state.cartAdditionalProperties.length ? {
        AdditionalProperties: this.state.cartAdditionalProperties
      } : null, this.state.inventoryStorePickupDetails, offering, completedDecisions, transitionOfferingIds).then(function () {
        _this15.closeSendToStorePopup();
        _this15.actions.unregisterUnsavedChanges('$ctrl.sendToStoreForm');
        _this15.onOrderActionSuccess(_this15.LocaleKeys.SEND_TO_STORE.SEND_SUCCESS);
      }).catch(function (error) {
        if (error.Code === EXISTING_SAVED_CART_FOR_SEND_TO_STORE_FAULT_CODE) {
          _this15.submitForPickupErrorPopupApi.open();
        } else {
          _this15.uiNotificationService.transientError(error.translatedMessage);
        }
      }).finally(function () {
        _this15.isSendToStoreLoading = false;
      });
    }
  }, {
    key: "onCartAdditionalPropertyListUpdated",
    value: function onCartAdditionalPropertyListUpdated() {
      this.actions.setEditCartAdditionalProperty(this.state.cartAdditionalPropertyListMap);
    }
  }, {
    key: "onCartAdditionalPropertyChanged",
    value: function onCartAdditionalPropertyChanged(id, newValue) {
      this.actions.setEditCartAdditionalPropertyOnChange(id, newValue);
    }
  }, {
    key: "onOrderAdditionalPropertyListUpdated",
    value: function onOrderAdditionalPropertyListUpdated() {
      this.actions.setEditOrderAdditionalProperty(this.state.orderAdditionalPropertyListMap);
    }
  }, {
    key: "onOrderAdditionalPropertyChanged",
    value: function onOrderAdditionalPropertyChanged(id, newValue) {
      this.actions.setEditOrderAdditionalPropertyOnChange(id, newValue);
    }
  }, {
    key: "changeOfferSubmitCOSOrder",
    value: function changeOfferSubmitCOSOrder(paymentInfo) {
      var _this16 = this;
      this.actions.transitionOfferSubmitCosOrder(this.state.customerId, this.state.selectedOfferId, this.state.addedItems, this.state.modifiedItems, this.state.removedItems, paymentInfo, this.offerId, this.state.changesEffective, this.state.executionOptions, this.state.recordPaymentInfo, pathOr(null, ['selectedOfferingPickupId', 'Id'], this.state), this.state.orderAdditionalProperties, this.state.selectedShippingAddressAndMethod).then(function () {
        _this16.isFormDirty = false;
        _this16.changeOrderConfirmationPopup.open();
      }).catch(function (error) {
        _this16.submitChangeOrderErrorPopupApi.open(error);
      });
    }
  }, {
    key: "onOrderActionSuccess",
    value: function onOrderActionSuccess(messageKey) {
      this.uiNotificationService.transientSuccess(i18n.translate(messageKey));
      this.redirectToCustomer();
    }
  }, {
    key: "redirectToCustomer",
    value: function redirectToCustomer() {
      this.actions.unregisterUnsavedChanges('wizardForm');
      this.isReturning = true;
      this.$state.go(CUSTOMER_URL, {
        'customerId': this.state.customerInfo.Id,
        'showAutoPayBanner': {
          enabled: this.state.showCustomerAutoPayBanner,
          customerId: this.state.customerInfo.Id
        }
      }, {
        reload: true
      });
    }
  }, {
    key: "tabSelected",
    value: function tabSelected(selectedTab) {
      var selectedIndex = findIndex(function (tab) {
        return tab === selectedTab;
      })(this.state.tabPanelViewModel);
      this.actions.setSelectedTab(selectedIndex);
    }
  }, {
    key: "updateCart",
    value: function updateCart(offerId) {
      var offeringInstanceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var completedDecisions = arguments.length > 2 ? arguments[2] : undefined;
      var isModify = arguments.length > 3 ? arguments[3] : undefined;
      var customerId = arguments.length > 4 ? arguments[4] : undefined;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      var contextOfferingAction = arguments.length > 6 ? arguments[6] : undefined;
      var transitionContext = arguments.length > 7 ? arguments[7] : undefined;
      var isConvergentBiller = arguments.length > 8 ? arguments[8] : undefined;
      var customerLanguage = arguments.length > 9 ? arguments[9] : undefined;
      this.actions.setDevicePaymentOptions([]);

      /**
      * Updates the cart, also handles the user language
      * @param {string} offerId
      * @param {number} offeringInstanceId
      * @param {[]} completedDecisions
      * @param {boolean} isModify
      * @param {number} customerId
      * @param {number} contextOfferingAction
      * @param {Object} transitionContext
      * @param {boolean} isConvergentBiller
      * @param {string} customerLanguage
      */

      /**Callback function passed in as callback
      *  @callback callback
      */

      this.actions.updateCart(this.state.selectedOfferId ? this.state.selectedOfferId : pathOr(null, ['Context', 'OfferingIds', '0'], this.state.storeOrder), offeringInstanceId, completedDecisions, isModify, customerId, callback, ContextOfferingAction.TRANSITION, transitionContext, isConvergentBiller, customerLanguage, this.state.selectedOfferingPickupId);
    }
  }, {
    key: "handleCloseSubmitChangeOrderErrorPopup",
    value: function handleCloseSubmitChangeOrderErrorPopup() {
      this.submitChangeOrderErrorPopupApi.close();
    }
  }, {
    key: "handleSubmitForPickupErrorPopup",
    value: function handleSubmitForPickupErrorPopup() {
      this.submitForPickupErrorPopupApi.close();
    }
  }, {
    key: "handleSubmitForPickupCancel",
    value: function handleSubmitForPickupCancel() {
      var _this17 = this;
      this.actions.cancelStoreOrder(this.state.customerInfo.Id).then(function () {
        _this17.handleSendToStore();
      }).catch(function (error) {
        _this17.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this17.submitForPickupErrorPopupApi.close();
      });
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.isReturning || this.state.isFetchingDecisionsOrAttributes || this.state.isCalculatingQuote || this.state.isSubmittingCOSOrder;
    }
  }, {
    key: "onSelectInventoryStore",
    value: function onSelectInventoryStore() {
      var _this18 = this;
      this.showSelectStorePopup = true;
      if (this.state.selectedInventoryRegion) {
        this.actions.setInventoryRegionFilter(this.state.selectedInventoryRegion);
      }
      this.$timeout(function () {
        _this18.selectStorePopupApi.open();
      });
    }
  }, {
    key: "openStoreSearch",
    value: function openStoreSearch() {
      var _this19 = this;
      var isSearchInventoriesAvailability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isSendToStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.showStoreInventoryPopup = true;
      this.isSubmitForPickUp = isSendToStore;
      this.$timeout(function () {
        _this19.storeSearchInventoryApi.open();
        if (isSearchInventoriesAvailability) {
          _this19.actions.searchInventoriesAvailability(_this19.state.formattedPhysicalInventories).then(function () {
            if (_this19.isInventoryItemReservationFault) {
              _this19.isInventoryItemReservationFault = false;
            }
          }).catch(_this19.onSearchInventoryAvailabilityFailure);
        }
      });
    }
  }, {
    key: "closeSelectStorePopupDialog",
    value: function closeSelectStorePopupDialog(applyChanges, selectedStore) {
      this.showSelectStorePopup = false;
      if (applyChanges) {
        this.actions.setSelectedInventoryStores([selectedStore]);
      }
      this.actions.setInventoryRegionFilter(null);
      this.selectStorePopupApi.close();
    }
  }, {
    key: "onInventoryRegionFilterChanged",
    value: function onInventoryRegionFilterChanged(region) {
      this.actions.setInventoryRegionFilter(region);
    }
  }, {
    key: "onUpdateSelectedServiceFeatures",
    value: function onUpdateSelectedServiceFeatures(attributeId, selectedServiceFeatures, billerRuleInstanceDetails) {
      var _this20 = this;
      var removedItems = clone(this.state.removedItems);
      if (!this.initialServiceFeatures[attributeId]) {
        this.state.formAttributeGroups.forEach(function (attributeGroup) {
          return attributeGroup.attributes.find(function (attribute) {
            if (attribute.id === attributeId) {
              return _this20.initialServiceFeatures[attributeId] = attribute.serviceFeatures;
            }
          });
        });
      }
      selectedServiceFeatures.forEach(function (serviceFeature) {
        if (!serviceFeature.SubscriberProductId) {
          if (_this20.initialServiceFeatures[attributeId] && _this20.initialServiceFeatures[attributeId].find(function (initialServiceFeature) {
            return initialServiceFeature.ProductId === serviceFeature.ProductId && initialServiceFeature.PricingPlanId === serviceFeature.PricingPlanId;
          })) {
            var restorableIndex = removedItems.findIndex(function (item) {
              return item.ProductId === serviceFeature.ProductId && item.PricingPlanId === serviceFeature.PricingPlanId;
            });
            if (restorableIndex > -1) {
              serviceFeature.SubscriberProductId = removedItems[restorableIndex].LockerItemId;
            }
          }
        }
      });
      this.actions.updateSelectedServiceFeatures(attributeId, selectedServiceFeatures, billerRuleInstanceDetails);
    }
  }, {
    key: "onMoreActionSelected",
    value: function onMoreActionSelected(action) {
      if (action === MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER) {
        this.actions.goToStep(LocaleKeys.WIZARD.STEPS.DECISIONS);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}(OfferWizard);
export default {
  template: require('./transition.offer.wizard.html'),
  controller: TransitionOfferWizardController
};